import ExcelJS from 'exceljs';
import TeamInformation from '../classes/TeamInformation';

/* eslint-disable */
export async function ImportKeikaku(destructionCost, keikaku, keikaku_ref1 = null, keikaku_ref2 = null, keikaku_ref3 = null)
{
    // Look for defined sheets
    const toyTeamSheetNames = ['トイ・ホビー','3部第1チーム【トイ・ホビー】', '411'];
    const digitalTeamSheetNames = ['414'];
    const gameTeamSheetNames = ['GAME', '3部第2チーム【ゲーム開発】', '421'];

    let wb = new ExcelJS.Workbook();

    let keikakuData = [];
    let keikaku_ref1_data = [];
    let keikaku_ref2_data = [];
    let keikaku_ref3_data = [];

    let result = [];

    // Check Keikaku file
    if (keikaku !== null)
    {
        const buffer = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => resolve(keikaku.File);
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(keikaku.File);
        });
        
        const keikakuWB = await wb.xlsx.load(buffer);
    
        keikakuWB.eachSheet(function(worksheet, sheetId)
        {
            if (toyTeamSheetNames.includes(worksheet.name) ||
                gameTeamSheetNames.includes(worksheet.name) ||
                digitalTeamSheetNames.includes(worksheet.name))
            {
                console.log(' ');
                console.log(' ');
                console.log(`[ImportKeikaku](ImportKeikaku) Revision: ${keikaku.Revision} Sheet: ${worksheet.name}`);
                console.log(' ');

                let supportWorksheet = null;
                let hasDestructionCost = false;

                // 411 (Toyhobby) covers 414 (digital)
                // regarding getting netincome information
                // because the staff-cost is the sum of both
                if (worksheet.name === '411')
                {
                    hasDestructionCost = true;
                    supportWorksheet = keikakuWB.getWorksheet('4311');
                }
                else if (worksheet.name === '421')
                {
                    supportWorksheet = keikakuWB.getWorksheet('4313');
                }

                keikakuData.push(CollectDataFromSheet(worksheet, hasDestructionCost ? destructionCost : null, keikaku.KeikakuYear, keikaku.Date.getMonth() + 1, false, supportWorksheet));
            }
        });

        result.push({ Revision: keikaku.Revision, Teams: keikakuData, Filename: keikaku.Filename, Date: keikaku.Date });
    }

    if (keikaku_ref1 !== null)
    {
        const buffer = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => resolve(keikaku_ref1.File);
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(keikaku_ref1.File);
        });

        const keikaku_ref1WB = await wb.xlsx.load(buffer);

        keikaku_ref1WB.eachSheet(function(worksheet, sheetId)
        {
            if (toyTeamSheetNames.includes(worksheet.name) ||
                gameTeamSheetNames.includes(worksheet.name) ||
                digitalTeamSheetNames.includes(worksheet.name))
            {
                console.log(' ');
                console.log(' ');
                console.log(`[ImportKeikaku](ImportKeikaku) ${keikaku_ref1.Revision} Sheet: ${worksheet.name}`);
                console.log(' ');
                keikaku_ref1_data.push(CollectDataFromSheet(worksheet, destructionCost, keikaku_ref1.KeikakuYear, keikaku_ref1.Date.getMonth() + 1, true));
            }
        });

        result.push({ Revision: keikaku_ref1.Revision, Teams: keikaku_ref1_data, Filename: keikaku_ref1.Filename, Date: keikaku_ref1.Date });
    }

    if (keikaku_ref2 !== null)
    {
        const buffer = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => resolve(keikaku_ref2.File);
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(keikaku_ref2.File);
        });

        const keikaku_ref2WB = await wb.xlsx.load(buffer);

        keikaku_ref2WB.eachSheet(function(worksheet, sheetId)
        {
            if (toyTeamSheetNames.includes(worksheet.name) ||
                gameTeamSheetNames.includes(worksheet.name) ||
                digitalTeamSheetNames.includes(worksheet.name))
            {
                console.log(' ');
                console.log(' ');
                console.log(`[ImportKeikaku](ImportKeikaku) ${keikaku_ref2.Revision} Sheet: ${worksheet.name}`);
                console.log(' ');
                keikaku_ref2_data.push(CollectDataFromSheet(worksheet, destructionCost, keikaku_ref2.KeikakuYear, keikaku_ref2.Date.getMonth() + 1, true));
            }
        });

        result.push({ Revision: keikaku_ref2.Revision, Teams: keikaku_ref2_data, Filename: keikaku_ref2.Filename, Date: keikaku_ref2.Date });
    }

    if (keikaku_ref3 !== null)
    {
        const buffer = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => resolve(keikaku_ref3.File);
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(keikaku_ref3.File);
        });

        const keikaku_ref3WB = await wb.xlsx.load(buffer);

        keikaku_ref3WB.eachSheet(function(worksheet, sheetId)
        {
            if (toyTeamSheetNames.includes(worksheet.name) ||
                gameTeamSheetNames.includes(worksheet.name) ||
                digitalTeamSheetNames.includes(worksheet.name))
            {
                console.log(' ');
                console.log(' ');
                console.log(`[ImportKeikaku](ImportKeikaku) ${keikaku_ref3.Revision} Sheet: ${worksheet.name}`);
                console.log(' ');
                keikaku_ref3_data.push(CollectDataFromSheet(worksheet, destructionCost, keikaku_ref3.KeikakuYear, keikaku_ref3.Date.getMonth() + 1, true));
            }
        });

        result.push({ Revision: keikaku_ref3.Revision, Teams: keikaku_ref3_data, Filename: keikaku_ref3.Filename, Date: keikaku_ref3.Date });
    }

    return result;
}

// Returns a TeamInformation instance
function CollectDataFromSheet(worksheet, destructionCost, keikakuYear, fileMonth, isMinaoshi, supportWorksheet = null)
{
    // -----------------------------------------
    // Trying to get the row by checking the content
    // of each cell starting from M1 (2025/01/07)
    // -----------------------------------------
    // for now we assume that the month's columns are
    // in row #5 and their value labels in row #6 for
    // the newer layouts, 2 and 3 respectively for old
    // layouts
    // const monthRow = 5;
    // const monthValueLabelRow = 6;
    // const oldMonthRow = 2;
    // const oldMonthValueLabelRow = 3;

    // The following labels are for finding the
    // column containing either the result or current
    // estimation values
    const column_Jisseki = '実積';
    const wrongJissekiKanji = '実績';
    const column_KeikakuPlanValue = '年初計画';

    // We have to go through rows (most likely B column)
    // and look for the following cell contents
    const salesRowLabel = '売上高'; //'売上高仮計'; // 売上 in mikomi
    const provProfitRowLabel = '営業総益仮計'; // 総益(仮) in mikomi
    const profitRowLabel = '営業総益'; // 総益 in mikomi
    const operatingProfitRowLabel = '事業営業利益'; // 営業利益 in mikomi
    const netIncomeRowLabel = '純利益'; // 純利益 in mikomi
    const stockRowLabel = '当月末在庫残高(簿価)'; // 在庫 in mikomi

    const dataRows = {
        salesRowNumber: 0,
        prov_profitRowNumber: 0,
        profitRowNumber: 0,
        operatingProfitRowNumber: 0,
        netIncomeRowNumber: 0,
        stockRowNumber: 0
    };

    let netIncomeUseSupportSheet = false;

    const team = new TeamInformation(GetTeamName(worksheet.name), keikakuYear);

    // Get date (expected in F4 cell)
    // const dateCell = worksheet.getRow(4).getCell(6);
    const lastRow = worksheet.actualRowCount;
    const lastColumn = worksheet.actualColumnCount;

    // First we try to find the rows in which we find
    // the values needed for each month.
    // We'll find the labels mostly either in column B or F
    // or G in case it's the old format
    // (2025/01/07) We just check all columns from A to O
    for (let row = 1; row <= lastRow; row++)
    {
        // First check column B
        const rowInstance = worksheet.getRow(row);
        for (let col = 1; col <= 15; col++)
        {
            const cell = rowInstance.getCell(col);
            const cellValue = (cell.value !== null && cell.value !== undefined) ? cell.value.toString() : '';

            switch(cellValue)
            {
                case salesRowLabel:
                    if (rowInstance.getCell(2).value === '合計')
                    {
                        dataRows.salesRowNumber = row;
                    }
                    break;

                case provProfitRowLabel:
                    dataRows.prov_profitRowNumber = row;
                    break;

                // Needs to be taken from the support sheet
                // case operatingProfitRowLabel:
                //     dataRows.operatingProfitRowNumber = row;
                //     break;

                case profitRowLabel:
                    if (rowInstance.getCell(2).value === '合計')
                    {
                        dataRows.profitRowNumber = row;
                    }
                    break;

                // Needs to be taken from the support sheet
                // case netIncomeRowLabel:
                //     dataRows.netIncomeRowNumber = row;
                //     break;

                case stockRowLabel:
                    dataRows.stockRowNumber = row;
                    break;
            }
        }

        /*
        const cellColumnB = rowInstance.getCell(2);
        const cellColumnF = rowInstance.getCell(6);
        const cellColumnG = rowInstance.getCell(7);
        const cellColumnH = rowInstance.getCell(8);

        const cellValueB = (cellColumnB.value !== null && cellColumnB.value !== undefined) ? cellColumnB.value.toString() : '';
        const cellValueF = (cellColumnF.value !== null && cellColumnF.value !== undefined) ? cellColumnF.value.toString() : '';
        const cellValueG = (cellColumnG.value !== null && cellColumnG.value !== undefined) ? cellColumnG.value.toString() : '';

        {
            if (cellValueB === salesRowLabel)
            {
                dataRows.salesRowNumber = row;
            }
            else if (cellValueB === provProfitRowLabel)
            {
                dataRows.prov_profitRowNumber = row;
            }
            else if (cellValueB === operatingProfitRowLabel)
            {
                dataRows.operatingProfitRowNumber = row;
            }
            else if (cellValueB === profitRowLabel)
            {
                dataRows.profitRowNumber = row;
            }
            else if (cellValueB === netIncomeRowLabel)
            {
                dataRows.netIncomeRowNumber = row;
            }
            else if (cellValueB === stockRowLabel)
            {
                dataRows.stockRowNumber = row;
            }
            else if (cellValueF === salesRowLabel)
            {
                dataRows.salesRowNumber = row;
            }
            else if (cellValueF === provProfitRowLabel)
            {
                dataRows.prov_profitRowNumber = row;
            }
            else if (cellValueF === operatingProfitRowLabel)
            {
                dataRows.operatingProfitRowNumber = row;
            }
            else if (cellValueF === profitRowLabel)
            {
                dataRows.profitRowNumber = row;
            }
            else if (cellValueF === netIncomeRowLabel)
            {
                dataRows.netIncomeRowNumber = row;
            }
            else if (cellValueF === stockRowLabel)
            {
                dataRows.stockRowNumber = row;
            }
            else if (cellValueG === salesRowLabel)
            {
                dataRows.salesRowNumber = row;
            }
            else if (cellValueG === provProfitRowLabel)
            {
                dataRows.prov_profitRowNumber = row;
            }
            else if (cellValueG === operatingProfitRowLabel)
            {
                dataRows.operatingProfitRowNumber = row;
            }
            else if (cellValueG === profitRowLabel)
            {
                dataRows.profitRowNumber = row;
            }
            else if (cellValueG === netIncomeRowLabel)
            {
                dataRows.netIncomeRowNumber = row;
            }
            else if (cellValueG === stockRowLabel)
            {
                dataRows.stockRowNumber = row;
            }
        }
        */
    }

    if (dataRows.netIncomeRowNumber === 0 &&
        supportWorksheet !== null)
    {
        console.log("have to get net income from another sheet");
        // 2025/01/31 Ikenouchi:
        /*
            ①売上　　　　　411 or  4311  OK
            ②総益(仮)     411 or  4311  OK
            ③事業営業利益  4311
            ④純利益        4311
            ⑤在庫          411
        */
        netIncomeUseSupportSheet = true;
        
        const supportSheetLastRow = supportWorksheet.actualRowCount;
        for (let row = 1; row <= supportSheetLastRow; row++)
        {
            const rowInstace = supportWorksheet.getRow(row);
            for (let col = 1; col <= 15; col++)
            {
                const cell = rowInstace.getCell(col);
                const cellValue = (cell.value !== null && cell.value !== undefined) ? cell.value.toString() : '';

                if (cellValue === netIncomeRowLabel)
                {
                    dataRows.netIncomeRowNumber = row;
                }
                else if (cellValue === operatingProfitRowLabel)
                {
                    dataRows.operatingProfitRowNumber = row;
                }
            }

            if (dataRows.netIncomeRowNumber !== 0 &&
                dataRows.operatingProfitRowNumber !== 0)
            {
                break;
            }
        }
    }

    console.log('data rows', dataRows);

    // Go through all columns in the month row
    // and cache the start/end columns of each month
    // and we exclude quarters, 下期/上期 and 合計 as we'll
    // qualculate those dynamically when needed
    let monthEntryCounter = 1;

    let row_month = null;
    let isOldFormat = false;
    // Find the row where month labels are written as
    // this seems to change every single time...
    // We start with the column m as it may start
    // from d, sometimes from j...
    for (let r = 1; r < 100; r++)
    {
        const cell = worksheet.getCell(`M${r}`);
        if (cell.value !== null &&
            cell.value !== '')
        {
            if (cell.value.includes('月') ||
                cell.value.includes('第1') ||
                cell.value.includes('上期') ||
                cell.value.includes('下期') ||
                cell.value.includes('年間'))
            {
                row_month = worksheet.getRow(r);
                break;
            }
        }
    }

    // -----------------------------------------
    // Trying to get the row by checking the content
    // of each cell starting from M1 (2025/01/07)
    // -----------------------------------------
    /*
    // Figure out if we have a sheet with the old format
    // or the new one. New formats won't have content in
    // cell O2 for example
    if (worksheet.getCell('O2').value !== null &&
        worksheet.getCell('O2').value !== '')
    {
        row_month = worksheet.getRow(oldMonthRow);
        isOldFormat = true;
    }
    else
    {
        row_month = worksheet.getRow(monthRow);
    }
    */

    // console.log(`（見直）計画 ${worksheet.name} sheet is old format: ${isOldFormat}`);

    for (let column = 1; column <= lastColumn; column++)
    {
        const cell = row_month.getCell(column);

        if (cell.value?.toString().includes('月') === true)
        {
            let monthNumber = parseInt(cell.value.replace('月',''));
            // Someone may be using full-width numbers...
            if (isNaN(monthNumber) === true)
            {
                monthNumber = GetHalfWidthNumber(cell.value.replace('月',''));
            }
            console.log(`Found month ${monthEntryCounter}月 in column #${column}`, monthNumber);

            const monthInfo = team.GetMonthInfo(monthNumber);

            if (monthInfo === undefined ||
                monthInfo === null)
            {
                console.log('no month result info instance for month number', monthNumber);
                return;
            }

            const row_monthValueLabels = worksheet.getRow(row_month.number + 1); // worksheet.getRow(isOldFormat ? oldMonthValueLabelRow : monthValueLabelRow);

            // If it's the year's first keikaku file, we don't have jisseki columns.
            // We have to look for 年初計画
            if (isMinaoshi === false)
            {
                let monthPlanValueColumn = 0;

                for (let subColumn = column; subColumn <= lastColumn; subColumn++)
                {
                    // Double check that we are still in the current month
                    // because some layouts may be inconsistent regarding the layout
                    // by checking the month row and compare with current month value
                    const checkMonthCell = row_month.getCell(subColumn);
                    const checkMonthNumber = checkMonthCell.value !== null ? parseInt(checkMonthCell.value.replace('月', '')) : monthNumber;

                    if (checkMonthNumber !== null &&
                        checkMonthNumber !== undefined &&
                        isNaN(checkMonthNumber) === false &&
                        checkMonthNumber !== monthNumber)
                    {
                        console.log('WE ARE OUT OF THE CURRENT MONTH BOUNDS AT COLUMN ' + subColumn);
                        // Use the previous column instead
                        monthPlanValueColumn = subColumn - 1;
                        break;
                    }

                    
                    const subCell = row_monthValueLabels.getCell(subColumn);
                    const subCellContent = subCell.result !== undefined ? subCell.result : subCell.value;
                    console.log(`sub cell content (${subColumn})`, subCellContent);

                    if (subCellContent === column_KeikakuPlanValue)
                    {
                        monthPlanValueColumn = subColumn;
                        break;
                    }
                }
                
                if (monthPlanValueColumn === 0)
                {
                    console.error('could not find keikaku month plan value column for month', monthNumber);
                    return;
                }

                monthInfo.Column = monthPlanValueColumn;
                
                // We probably need to use the support sheet for netIncome

                CollectMonthData(monthInfo, worksheet.getColumn(monthPlanValueColumn), dataRows, destructionCost, netIncomeUseSupportSheet ? supportWorksheet : null);
                column += 1;
                monthEntryCounter++;
            }
            else
            {
                // Go through the columns in the following row
                // to find out if we have a jisseki or estimation value.
                // First we check in which column the result value is
                // and then we check if it's != 0 (we just assume it won't be 0
                // if we have jisseki values)
                let monthJissekiColumn = 0;
                let hasJissekiColumn = true;

                for (let subColumn = column; subColumn <= lastColumn; subColumn++)
                {
                    // Double check that we are still in the current month
                    // because some layouts may be inconsistent regarding the layout
                    // by checking the month row and compare with current month value
                    const checkMonthCell = row_month.getCell(subColumn);
                    const checkMonthNumber = checkMonthCell.value !== null ? parseInt(checkMonthCell.value.replace('月')) : monthNumber;
                    if (checkMonthNumber !== monthNumber)
                    {
                        console.log('WE ARE OUT OF THE CURRENT MONTH BOUNDS AT COLUMN ' + subColumn);
                        // Use the previous column instead
                        monthJissekiColumn = subColumn - 1;
                        hasJissekiColumn = false;
                        break;
                    }

                    const subCell = row_monthValueLabels.getCell(subColumn);
                    const subCellContent = subCell.result !== undefined ? subCell.result : subCell.value;

                    //console.log('subCellContent in column ' + subColumn, subCellContent);
                    
                    if (subCellContent === column_Jisseki ||
                        subCellContent === wrongJissekiKanji)
                    {
                        monthJissekiColumn = subColumn;
                        break;
                    }
                }

                if (monthJissekiColumn === 0)
                {
                    console.error('could not find jisseki column for month', monthNumber);
                    return;
                }

                // console.log(`Month ${monthNumber} has jisseki in column ${monthJissekiColumn}`);

                // Check first if the jisseki value is != 0
                // If so, we have jisseki data for the month
                // If not, we have to check previous columns
                // We use net income as we might not have sales
                let dataRow = worksheet.getRow(dataRows.operatingProfitRowNumber);
                let dataCell = dataRow.getCell(monthJissekiColumn);
                let dataValue = parseInt(dataCell.result === undefined ? dataCell.value : dataCell.result);

                if (hasJissekiColumn === true &&
                    monthNumber < fileMonth &&
                    dataValue !== 0 ||
                    hasJissekiColumn === false &&
                    dataValue !== 0)
                {
                    monthInfo.Column = monthJissekiColumn;
                    // console.log('get month data from jisseki column', `row ${dataRows.operatingProfitRowNumber} column ${monthJissekiColumn}`);
                    CollectMonthData(monthInfo, worksheet.getColumn(monthJissekiColumn), dataRows, destructionCost);
                }
                // Try previous column
                else
                {
                    let checkColumn = monthJissekiColumn;
                    do {
                        checkColumn--;
                        dataCell = dataRow.getCell(checkColumn);
                        console.log(`Check value in cell row ${dataRows.operatingProfitRowNumber} column ${checkColumn}`, dataCell.value);
                        console.log(`Check result in cell row ${dataRows.operatingProfitRowNumber} column ${checkColumn}`, dataCell.result);
                        dataValue = parseInt(dataCell.result === undefined ? dataCell.value : dataCell.result);
                        console.log('dataValue->', dataValue);
                    } while (dataValue === 0 && checkColumn >= column);

                    if (dataValue !== 0)
                    {
                        monthInfo.Column = checkColumn;
                        console.log('get month data from non-jisseki column ', `row ${dataRows.operatingProfitRowNumber} column ${checkColumn}`);
                        CollectMonthData(monthInfo, worksheet.getColumn(checkColumn), dataRows, destructionCost);
                    }
                    else
                    {
                        console.log('could not find values for month', monthNumber);
                    }
                }

                // console.log('add ' + (monthJissekiColumn - column) + ' to current column ('+column+') number');
                column += monthJissekiColumn - column;
                monthEntryCounter++;
            }
        }
    }

    console.log(`[ImportKeikaku.js](ImportKeikaku) (${worksheet.name}) Team: ${team.Teamname}`, team);
    return team;
}

function GetHalfWidthNumber(fullWidthNumberString)
{
    switch(fullWidthNumberString)
    {
        case '１': return 1;
        case '２': return 2;
        case '３': return 3;
        case '４': return 4;
        case '５': return 5;
        case '６': return 6;
        case '７': return 7;
        case '８': return 8;
        case '９': return 9;
        case '１０': return 10;
        case '１１': return 11;
        case '１２': return 12;

        default:
            console.log('not supported full-width number string', fullWidthNumberString);
            return 0;
    }
}

/**
 * 
 * @param {*} monthInfo MontInformation instance
 * @param {*} column Column instance from worksheet
 * @param {*} dataRows Object containing the row index for each data type
 * @param {*} destructionCost object containing June and November destruction cost
 * @param {*} supportWorksheet In case values need to be taken from a separate sheet
 */
function CollectMonthData(monthInfo, column, dataRows, destructionCost, supportWorksheet = null)
{
    column.eachCell({includeEmpty: true}, (cell, rowNumber) => {
        if (rowNumber === dataRows.salesRowNumber)
        {
            monthInfo.Sales = parseInt(cell.result === undefined ? cell.value : cell.result);
        }
        else if (rowNumber === dataRows.prov_profitRowNumber)
        {
            monthInfo.ProvProfit = parseInt(cell.result === undefined ? cell.value : cell.result);
        }
        else if (rowNumber === dataRows.profitRowNumber)
        {
            monthInfo.Profit = parseInt(cell.result === undefined ? cell.value : cell.result);
        }
        else if (supportWorksheet === null && rowNumber === dataRows.netIncomeRowNumber)
        {
            monthInfo.NetIncome = parseInt(cell.result === undefined ? cell.value : cell.result);
        }
        else if (rowNumber === dataRows.stockRowNumber)
        {
            monthInfo.Zaiko = parseInt(cell.result === undefined ? cell.value : cell.result);
        }
        else if (supportWorksheet === null && rowNumber === dataRows.operatingProfitRowNumber)
        {
            monthInfo.OperatingProfit = parseInt(cell.result === undefined ? cell.value : cell.result);
        }
    });

    if (supportWorksheet !== null)
    {
        console.log('get support col at col ', column.number + 2);
        const suppCol = supportWorksheet.getColumn(column.number + 2);
        suppCol.eachCell({includeEmpty: true}, (cell, rowNumber) => {
            if (rowNumber === dataRows.netIncomeRowNumber)
            {
                monthInfo.NetIncome = Math.round(parseFloat(cell.result === undefined ? cell.value : cell.result));
            }
            else if (rowNumber === dataRows.operatingProfitRowNumber)
            {
                monthInfo.OperatingProfit = Math.round(parseFloat(cell.result === undefined ? cell.value : cell.result));
            }
        })
    }

    if (destructionCost !== null)
    {
        if (monthInfo.Month === 6)
        {
            monthInfo.DestroyCost = destructionCost.June;
        }
        else if (monthInfo.Month === 11)
        {
            monthInfo.DestroyCost = destructionCost.November;
        }
    }
    // monthInfo.Figures_SalesAmount = parseInt(column.getCell(dataRows.salesRowNumber).value);
    // monthInfo.Figures_GrossOperatingProfit = parseInt(column.getCell(dataRows.operatingProfit_prov_RowNumber).value);
    // monthInfo.ResultGrossOperatingProfit = parseInt(column.getCell(dataRows.operatingProfitRowNumber).value);
}

function GetTeamName(sheetName)
{
    switch(sheetName)
    {
        case "Toy":
        case "toy":
        case "3部第1チーム【トイホビー】":
        case "3部第1チーム【トイ・ホビー】":
        case "【トイ・ホビー】":
        case "【トイホビー】":
        case "3部【トイ・ホビー】":
        case "2024部別決算【トイホビー】":
        case "トイ・ホビー":
        case "411":
            return "トイホビー";

        case "3部第2チーム【ゲーム開発】":
        case "【ゲーム開発】":
        case "3部【ゲーム開発】":
        case "2024部別決算【ゲーム開発】":
        case "GAME":
        case "421":
            return "ゲーム開発";

        case "3部第2チーム【デジタル】":
        case "【デジタル】":
        case "3部【デジタル】":
        case "2024部別決算【デジタル】":
        case "414":
            return "デジタル";

        case "2023部別決算【3部合計】":
            console.log("(2023)3Bu TTL not yet implemented: ");
            return "Unsupported_TeamName";

        case "2024部別決算【3部合計】":
            console.log("(2024)3Bu TTL not yet implemented: ");
            return "Unsupported_TeamName";

        default:
            console.log("Unsupported team name: " + sheetName);
            return "Unsupported_TeamName";
    }
}